import { Link } from "react-router-dom";
import { contents } from "@/mocks/contents";
import { getCategoryById } from "@/utils/content";

export default function LatestUpdates() {
  const latest = [...contents]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 8);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <ul className="divide-y divide-background-100">
        {latest.map((item) => {
          const cat = getCategoryById(item.categoryId);
          return (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                className="group flex items-center gap-4 px-4 md:px-5 py-3.5 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-12 h-16 md:w-14 md:h-[74px] shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} 最新更新封面`}
                    title={`${item.title} 国语对白影音资源`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 truncate">{item.summary}</p>
                  <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-400">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800">{cat?.name}</span>
                    <span>{item.region}</span>
                  </div>
                </div>
                <div className="shrink-0 text-right">
                  <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-refresh-line" />
                    更新
                  </span>
                  <span className="mt-1 block text-xs text-foreground-600">{item.updatedAt}</span>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
      <Link
        to="/category/movie"
        className="block py-3 text-center text-sm text-foreground-600 hover:text-accent-600 hover:bg-background-100 transition-colors cursor-pointer border-t border-background-100"
      >
        查看更多更新
        <i className="ri-arrow-right-s-line ml-0.5 align-middle" />
      </Link>
    </div>
  );
}